import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SoaImageService } from './../../services/soa-image.service';
import { DatePipe } from '@angular/common';
import { ContactService } from './../../services/contact.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';
import { FactoringTabService } from './../../services/factoring-tab.service';


@Component({
  selector: 'app-factoring-tab1',
  templateUrl: './factoring-tab1.component.html',
  styleUrls: ['./factoring-tab1.component.css']
})
export class FactoringTab1Component implements OnInit {
  modalRef: BsModalRef;
  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };
  maxDate: Date;
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  factTabList: any = [];
  customerList: object = [];
  customerModel: any = {};
  customerModel1: any = {};
  FactFolderList: any;
  mobileFolderList: any = [];
  temp_var: any = false;
  model: any = {};
  customer_id: any = '';
  invoice_id: any = '';
  delete_id: any = '';

  arrayOne(n: number): any[] {
    return Array(n);
  }
  pdfSrc: any = '';
  loaderMode = false;

  emailModel: any = {};

  emailModal: any = true;
  emailModalError: any = false;


  constructor(private modalService: BsModalService,
    private _factTap2: FactoringTabService,
    private _contact: ContactService, private _soaImage: SoaImageService,
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private SoaImageService: SoaImageService,
    private _factInvoice: FactoringInvoiceService, private datePipe: DatePipe,) { }


  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.maxDate = new Date();
    this.getfactInvoice();

    //get customer for mobile and other role user
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }
    this._contact.getContactList(customerModal)
      .subscribe(
        res => {
          // this.customerList=res;
          //   if(res.status=='true'){
          this.customerList = res;

          //   }
        },
      );
    ////end


  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }



  getCustomerEmail(customer_id, invoice_id) {
    this.emailModalError = false;
    // this.loaderMode=true;
    this.invoice_id = invoice_id;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {
        // console.log(res.data);
        this.emailModel = res.data;
      },
    );
  }


  sendEmailToCust() {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      invoice_id: this.invoice_id
    }


    this._factInvoice.sendEmailToCustomer(folderModel).subscribe(
      res => {

        this.modalRef.hide();
        this.emailModal = false;
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }

        //  this._router.navigateByUrl('/redirect').then(() => {
        //  this._router.navigateByUrl('/factoring/factoring-tab1');
        // });
      },
    );

    /*if(this.emailModal){
     const rload=this;
     setTimeout(function(){  rload.emailModalError=true;}, 1000);
    } */

  }


  setpdfSrc(src) {
    this.pdfSrc = src;
  }


  onChangeFactStatus(value) {  //alert(value);
    const data = {
      invoice_id: value,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      // status: 'approved',
      status: 'Need SOA',
    }

    this._factInvoice.changeFactoringStatus(data)
      .subscribe(
        res => {
          // console.log(res);
          // this.ngOnInit();
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab3');
          });
        },
        err => console.log(err)
      );
  }

  getfactInvoice() {
    this.loaderMode = true;
    ///////get factoring invoice
    const invoiceModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      customer_id: this.customer_id,
      company_id: this.company_id,
      status: 'opted_out',
    }
    //console.log(customerModal);
    this._factTap2.getFactFolderList(invoiceModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          // console.log(res);
          this.factTabList = res;
          // console.log('hi');
          this.temp_var = true;

        },
      );
    ////end 


  }




  onChangeCust(value) {
    this.customer_id = value;
    this.getfactInvoice();
  }



}

